import type React from 'react';
import { getFontMimeType, generateFontFaceCSS, generateFontVariableCSS, FontRegistry } from './fontRegistryUtils';

export const FontRegistryPreloadHeaders: React.FC = () => {
  return FontRegistry.fonts.map((font) =>
    font.src
      .map((file) =>
        file.preload ? (
          <link
            key={file.path}
            rel='preload'
            href={file.path}
            as='font'
            type={getFontMimeType(file.path)}
            crossOrigin='anonymous'
            data-font-registry
          />
        ) : null,
      )
      .filter((element) => element !== null),
  );
};

export const FontRegistryStyles: React.FC = () => {
  return (
    <style
      data-font-registry
      dangerouslySetInnerHTML={{
        __html: generateFontFaceCSS() + generateFontVariableCSS(),
      }}
    />
  );
};
